export const downloadUrl = (url: string) => {
  var a = document.createElement("a");
  a.href = url;
  a.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
